import React from "react";

const steps = [
    {
        n: "01",
        title: "Brief",
        body: "Share the event idea, venue plans, measurements, references, brand assets, deadlines and any practical requirements.",
    },
    {
        n: "02",
        title: "Model",
        body: "The space is built or developed in 3D using the available information, with key event elements placed to test layout, scale and flow.",
    },
    {
        n: "03",
        title: "Visualise",
        body: "The model is developed into clear views, layouts or renders that communicate the concept and important spatial decisions.",
    },
    {
        n: "04",
        title: "Refine",
        body: "Visuals are adjusted based on feedback, supplier input, budget realities, client direction or production requirements.",
    },
    {
        n: "05",
        title: "Package",
        body: "Final visuals are exported for use in pitches, client approvals, supplier briefs, planning documents or production discussions.",
    },
];

export default function Process() {
    return (
        <section
            id="process"
            data-testid="process-section"
            className="section-pad border-t border-border"
        >
            <div className="container-edge">
                <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
                    <div className="md:col-span-5">
                        <h2
                            data-testid="process-heading"
                            className="font-display text-4xl md:text-5xl lg:text-6xl tracking-tight font-medium leading-[1.02] text-balance"
                        >
                            From rough idea to{" "}
                            <span className="italic font-normal text-champagne">
                                clear visual direction.
                            </span>
                        </h2>
                    </div>
                    <p className="md:col-span-7 md:pt-12 text-foreground/70 text-[15px] leading-relaxed max-w-2xl">
                        A five-step working process designed to keep things
                        transparent, decisions visible and the visual language
                        evolving alongside the project.
                    </p>
                </div>

                <div className="mt-20 border-t border-border">
                    {steps.map((s, i) => (
                        <div
                            key={s.n}
                            data-testid={`process-step-${i}`}
                            className="group grid grid-cols-1 md:grid-cols-12 gap-6 border-b border-border py-10 md:py-14 hover:bg-foreground/[0.02] transition-colors"
                        >
                            <div className="md:col-span-2 flex items-start">
                                <span className="font-display text-5xl md:text-6xl font-medium tracking-tighter text-foreground/30 group-hover:text-foreground transition-colors">
                                    {s.n}
                                </span>
                            </div>
                            <div className="md:col-span-4">
                                <h3 className="font-display text-3xl md:text-4xl font-medium tracking-tight">
                                    {s.title}
                                </h3>
                            </div>
                            <div className="md:col-span-6">
                                <p className="text-foreground/75 text-[15px] leading-relaxed max-w-xl">
                                    {s.body}
                                </p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
